import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AppointmentStatePicker } from '../../../../components/entity-picker/appointmentStatePicker/AppointmentStatePicker';
import { FilterCard } from '../filter-card/FilterCard';

export type IAppointmentStateFilterCardProps = {
  title: string;
  value: { id?: number; name?: string }[] | null;
  onChange: (value: { id?: number; name?: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const AppointmentStateFilterCard: React.FC<
  IAppointmentStateFilterCardProps
> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return t('TASK_STATUS.' + value[0].id);
    return value.length + ' ' + t('COMMON.CHOSEN');
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <AppointmentStatePicker
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
      />
    </FilterCard>
  );
};
